import * as d3 from 'd3';
import $ from 'jquery';
import { each } from 'lodash';

let svg = null;
let x = null;
let height = null;
let width = null;
export const createRange = function(settings) {
  let divId = settings.el;
  let margin = settings.margin;
  var parent = d3.select('#' + divId);

  // Add class to parent div so that our css selectors can be scoped
  parent.classed('range-chart', true);

  width = 176;
  height = 18;

  svg = parent
    .append('svg')
    .attr('overflow', 'visible')
    .attr('width', 200)
    .attr('height', 50)
    .append('g')
    .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

  svg
    .append('g')
    .attr('class', 'x_axis')
    .attr('font-family', 'GTAR')
    .attr('font-size', '12')
    .attr('transform', 'translate(10,10)');

  svg.append('g').attr('class', 'y_axis');

  // Outline rect
  svg
    .append('rect')
    .attr('y', 0)
    .attr('width', width)
    .attr('height', height)
    .attr('stroke-width', 2)
    .attr('stroke', '#4D4D4F')
    .attr('fill', 'none');

  // Patient indicator
  svg
    .append('rect')
    .attr('id', 'indicator-rect')
    .attr('x', 0)
    .attr('y', 2) // Cover the graph edge
    .attr('width', 3)
    .attr('height', height - 3)
    .attr('rx', 2)
    .attr('ry', 2)
    .attr('stroke-width', 3)
    .attr('stroke', 'none');

  // Range rect
  svg
    .append('rect')
    .attr('id', 'range-rect')
    .attr('y', 0)
    .attr('width', width)
    .attr('height', height)
    .attr('stroke-width', 2)
    .attr('stroke', '#4D4D4F')
    .attr('fill', 'none');

  var deferred = new $.Deferred();
  deferred.resolve('resolved');
  return deferred;
};

export const updateRange = function(data) {
  const id = data.id || '??';
  let ranges = data.ranges;
  let min = data.min;
  let max = data.max;
  x = d3.scale.linear().range([0, width]);

  x.domain([min, max]);

  var xAxis = d3.svg
    .axis()
    .scale(x)
    .ticks(5)
    .orient('bottom')
    .tickSize(0)
    .tickPadding(20);

  svg
    .select('.x_axis')
    .call(xAxis)
    .select('.ticks')
    .remove();

  // Delete old range lines
  svg.selectAll('line').remove();

  each(ranges, range => {
    svg
      .append('line')
      .attr('x1', x(range.min))
      .attr('y1', 0)
      .attr('x2', x(range.min))
      .attr('y2', height)
      .attr('stroke-width', 2)
      .attr('stroke', '#4D4D4F')
      .attr('fill', '#ff0000');
    //   .moveToBack();
  });

  svg
    .select('#indicator-rect')
    .transition()
    .attr('x', x(data.value))
    .attr('fill', data.color);

  svg
    .select('#range-rect')
    .transition()
    .attr('x', x(data.selected.min))
    .attr('width', x(data.selected.max) - x(data.selected.min))
    .attr('stroke-width', 3)
    .attr('stroke', data.color);
};
